import React from 'react';
import {
  LedgerHeader,
  ledgerContainerClass,
  type LedgerCollapse,
  type LedgerColumn,
} from '@billda/design-system';
import { GangListItem } from '../molecules/GangListItem';
import { ListViewShell } from '../../../../shared/components/ui/ListViewShell';

type GangMember = {
  userId: string;
  givenName?: string | null;
  familyName?: string | null;
  isLeader: boolean;
  canSeeSplit?: boolean | null;
};

export interface GangItem {
  id: string;
  name: string;
  isEqualSplit: boolean;
  members: GangMember[];
}

const GANGS_COLLAPSE: LedgerCollapse = {
  container: 'gangs-collection',
  at: 620,
};

const GANGS_COLUMNS: LedgerColumn[] = [
  { key: 'members', label: 'Members', flex: 0.9 },
  { key: 'leaders', label: 'Leaders', flex: 0.9, hideBelow: 760 },
  { key: 'split', label: 'Split', flex: 0.8 },
];

export interface GangsListViewProps {
  gangs: GangItem[];
  loading: boolean;
  onRowClick?: (id: string) => void;
}

export const GangsListView: React.FC<GangsListViewProps> = ({
  gangs,
  loading,
  onRowClick,
}) => {
  return (
    <div className={ledgerContainerClass(GANGS_COLLAPSE.container)}>
      <ListViewShell
        itemCount={gangs.length}
        loading={loading}
        emptyMessage="No gangs found"
        data-testid="gangs-table"
      >
        <LedgerHeader
          columns={GANGS_COLUMNS}
          collapse={GANGS_COLLAPSE}
          titleLabel="Name"
          showValues={false}
          showActions
          hideBelow={GANGS_COLLAPSE.at}
        />
        {gangs.map(gang => (
          <GangListItem
            key={gang.id}
            gang={gang}
            columns={GANGS_COLUMNS}
            collapse={GANGS_COLLAPSE}
            onRowClick={onRowClick}
          />
        ))}
      </ListViewShell>
    </div>
  );
};
